/* tslint:disable */
/* eslint-disable */
/* @relayHash c2e488f71399a3082e2393df04ffa352 */

import { ConcreteRequest } from "relay-runtime";
export type AutomatedCheckModalMutationVariables = {
    delegateUUID: string;
};
export type AutomatedCheckModalMutationResponse = {
    readonly startVerify: string;
};
export type AutomatedCheckModalMutation = {
    readonly response: AutomatedCheckModalMutationResponse;
    readonly variables: AutomatedCheckModalMutationVariables;
};



/*
mutation AutomatedCheckModalMutation(
  $delegateUUID: UUID!
) {
  startVerify(delegateUUID: $delegateUUID)
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "delegateUUID",
            "type": "UUID!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "startVerify",
            "args": [
                {
                    "kind": "Variable",
                    "name": "delegateUUID",
                    "variableName": "delegateUUID"
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "AutomatedCheckModalMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "AutomatedCheckModalMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "AutomatedCheckModalMutation",
            "id": null,
            "text": "mutation AutomatedCheckModalMutation(\n  $delegateUUID: UUID!\n) {\n  startVerify(delegateUUID: $delegateUUID)\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'bfe7750104e05f76c12b5d7902eaf42c';
export default node;
